import { ApplicationConfig, ErrorHandler, importProvidersFrom, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient } from '@angular/common/http';
import { JoyrideModule } from 'ngx-joyride';
import { routes } from './app-routing.module';
import { AnalyticsService } from './services/analytics.service';
import { PosthogErrorHandler } from './services/posthog-error-handler';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideClientHydration(),
    provideAnimationsAsync(),
    provideHttpClient(),
    provideAppInitializer(() => inject(AnalyticsService).init()),
    importProvidersFrom(JoyrideModule.forRoot()),
    { provide: ErrorHandler, useClass: PosthogErrorHandler }
  ]
};

export class ConfigService {
  constructor() { }
}
